import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import BaseButton from '../form/BaseButton.jsx';
import BaseOverlay from '../layout/BaseOverlay.jsx';
import IconCancel from '../images/IconCancel.jsx';
import BaseTreeSelect from '../form/BaseTreeSelect.jsx';

const AdvancedSearchFilter = ({ filters, visible, setVisible, config, changeFilter, applyFilters, setApplied }) => {
    const hideDialog = () => {
        setVisible(false);
    };

    const handleTreeSelectChange = (field, value, options, setSelectedTreeValues) => {
        setSelectedTreeValues(value);

        let arr = [];
        Object.entries(value).forEach(([key, type]) => {
            let split = key.split('-');
            let element = options[split[0]];

            if (split.length > 1) {
                split.slice(1).forEach((index) => {
                    element = element.children[index];
                });
            }

            if (type.checked) {
                arr.push(element.data);
            }
        });

        changeFilter(field, arr);
    };

    const removeTreeSelect = (field, setSelectedTreeValues) => {
        setSelectedTreeValues({});
        changeFilter(field, []);
    };

    const simpleSelectChangeFilter = (field, value) => {
        if (filters[field] === value) {
            changeFilter(field, null);
        } else {
            changeFilter(field, value);
        }
    };

    const filter = () => {
        applyFilters();
        setApplied(true);
        hideDialog();
    };

    const renderSimpleSelect = ({ title, field, elements, options }) => {
        return (
            <div className={'mb-[30px]'} key={field}>
                <h2 className='pb-[10px] text-xl font-bold'>{title}</h2>
                <div>
                    {options.map((item, index) => {
                        return (
                            <div
                                key={`${field}-${item.value}-${index}`}
                                className={`inline-flex mr-3 w-min rounded-4xl border border-theme1-text3 px-4 py-2 mb-2 items-center ${filters[field] === item.value ? 'bg-theme1-primary' : ''}`}
                                onClick={() => simpleSelectChangeFilter(field, item.value)}
                            >
                                {elements(field, item)}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    const renderMultiSelect = ({ field, options, title, placeholder }) => {
        return (
            <div className={'mb-[30px] leading-tight'} key={field}>
                <h2 className='pb-[10px] text-xl font-bold'>{title}</h2>
                <div className='flex items-center gap-2'>
                    <MultiSelect
                        value={filters[field]}
                        onChange={(e) => changeFilter(field, e.value)}
                        options={options}
                        optionLabel='label'
                        filter
                        placeholder={placeholder}
                        maxSelectedLabels={3}
                        className={`bg-transparent border-theme1-text3 border rounded-4xl px-2 ${filters[field].length > 0 ? 'w-[90%]' : 'w-full'}`}
                    />

                    {filters[field].length > 0 && (
                        <div className='cursor-pointer w-[36px] flex-shrink-0' onClick={() => changeFilter(field, [])}>
                            <IconCancel className='fill-theme1-primary' />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderTreeSelect = ({ field, options, title, placeholder, value, setValue }) => {
        return (
            <div className={'mb-[30px] leading-tight'} key={field}>
                <h2 className='pb-[10px] text-xl font-bold'>{title}</h2>
                <div className='flex items-center gap-2'>
                    <BaseTreeSelect
                        name={field}
                        label={placeholder}
                        placeholder={placeholder}
                        inputClassName='md:w-20rem w-full rounded-full h-[48px]'
                        value={value}
                        setValue={setValue}
                        options={options}
                        selectionMode='checkbox'
                        display='chip'
                        showClear={false}
                        filter={true}
                        filterMode={'strict'}
                        filterDelay={10}
                        onSelect={(data) => handleTreeSelectChange(field, data, options, setValue)}
                    />

                    {filters[field]?.length > 0 && (
                        <div
                            className='cursor-pointer w-[36px] flex-shrink-0'
                            onClick={() => removeTreeSelect(field, setValue)}
                        >
                            <IconCancel className='fill-theme1-primary' />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <BaseOverlay show={visible} className='overflow-auto h-[100dvh] rounded-none'>
            <div className='min-h-96 max-w-3xl w-full mx-auto p-4'>
                <div className='flex justify-end py-4'>
                    <div className='text-theme1-primary font-bold cursor-pointer' onClick={hideDialog}>
                        Close
                    </div>
                </div>
                <div className='text-center text-theme1-title2 font-bold text-[22px] mb-3'>Filter</div>
                <div className={'text-left'}>
                    {config.map((item) => {
                        switch (item.type) {
                            case 'multiselect':
                                return renderMultiSelect(item);
                            case 'singleselect':
                                return renderSimpleSelect(item);
                            case 'treeselect':
                                return renderTreeSelect(item);
                        }
                    })}
                    <div className='flex justify-between gap-4 w-full'>
                        <BaseButton
                            className='bg-theme1-primary text-theme1-white flex-shrink-0'
                            textValue='Apply Filters'
                            onClick={filter}
                        />
                    </div>
                </div>
            </div>
        </BaseOverlay>
    );
};

export default AdvancedSearchFilter;
